export default __webpack_public_path__ + "static/media/BETU.5d42dc66.png";